import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import cartReducer from './slices/cartSlice';
import productsReducer from './slices/productsSlice';
import auctionsReducer from './slices/auctionsSlice';
import preOrdersReducer from './slices/preOrdersSlice';
import tradeInsReducer from './slices/tradeInsSlice';
import searchReducer from './slices/searchSlice';
import paymentsReducer from './slices/paymentsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    cart: cartReducer,
    products: productsReducer,
    auctions: auctionsReducer,
    preOrders: preOrdersReducer,
    tradeIns: tradeInsReducer,
    search: searchReducer,
    payments: paymentsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
